import { render } from "./BasicUsage.vue?vue&type=template&id=56cc4f15"
import script from "./BasicUsage.vue?vue&type=script&lang=ts"
export * from "./BasicUsage.vue?vue&type=script&lang=ts"
script.render = render

export default script